import { render, staticRenderFns } from "./allocationModal.vue?vue&type=template&id=5c0865fd&scoped=true&"
import script from "./allocationModal.vue?vue&type=script&lang=js&"
export * from "./allocationModal.vue?vue&type=script&lang=js&"
import style0 from "./allocationModal.vue?vue&type=style&index=0&id=5c0865fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0865fd",
  null
  
)

export default component.exports